module.exports = __webpack_public_path__ + "img/ES3118.f4988959.png";